const MONTHS_ID = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli",
  "Agustus", "September", "Oktober", "November", "Desember"];

export function rupiah(n) {
  if (n === null || n === undefined || isNaN(n)) return "Rp 0";
  return "Rp " + Math.round(n).toLocaleString("id-ID");
}

export function angka(n) {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return Number(n).toLocaleString("id-ID");
}

export function tanggal(v) {
  if (!v) return "-";
  try {
    const d = new Date(String(v).slice(0, 10) + "T00:00:00");
    return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return String(v);
  }
}

export function tanggalWaktu(v) {
  if (!v) return "-";
  try {
    const d = new Date(v);
    return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  } catch {
    return String(v);
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
